<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title class="mb-50">  کاربران </b-card-title>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts
        type="bar"
        height="270"
        :options="columnChart.chartOptions"
        :series="columnChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    flatPickr,
    BCardTitle,
  },
  data() {
    return {
      columnChart: {
        series: [
          {
            name: "کاربران فعال",
            data: [90, 120, 55, 100, 80,],
          },
          {
            name: "کاربران غیر فعال",
            data: [85, 100, 30, 40, 95],
          },
        ],
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          colors: ["#7eefc7", "#06774f"],
          plotOptions: {
            bar: {
              columnWidth: "40%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: true,
            position: "top",
            fontSize: "14px",
            fontFamily: "Montserrat",
            horizontalAlign: "left",
          },
          stroke: {
            show: true,
            colors: ["transparent"],
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            categories: ["دوره ۱", "دوره 2", "دوره 3", "دوره 4", "دوره 5"],
          },
          yaxis: {
            opposite: true,
            
          },
          fill: {
            opacity: 1,
          },
        },
      },
    };
  },
};
</script>
